export const enum EWBSView {
  EAP = 5,
  VIEWER_3D = 6,
}

export const enum ELeftMenuTab {
  CLOSED = -1,
  NAVIGATOR = 0,
  LIBRARIES = 1,
  COST_PLANS = 4,
}

export const enum ERightMenuTab {
  PROPERTIES = 0,
  MODEL_MAPS = 1,
  COMPOSITIONS = 2,
  HELP = 3,
}

export const enum EModelMapTab {
  CONFIGURATION = 0,
  FILTER = 1,
  FORMATING = 2,
}

export enum ESearchTabs {
  EAP_LINE,
  RESOURCES,
  COMPOSITIONS,
}



// WEBPACK FOOTER //
// ./src/common/enums/Tabs.ts